import { AnyAction } from 'redux';

const DATA_SEARCH_HISTORY = 'DATA_SEARCH_HISTORY';

const initialState = { history: [] };

export function setSearchHistory(dispatch: any, searchHistory: any) {
    dispatch({
        type: DATA_SEARCH_HISTORY,
        data: searchHistory
    });
};

export const searchReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case DATA_SEARCH_HISTORY: {
            const data = {
                ...state,
                history: action.data.history
            };
            return data;
        };
        default:
            return state;
    }
};
